import { useCallback } from 'react'

import { SERVER_URL } from 'src/constants/serverUrl'
import { useSelectedTrial } from 'src/features/auth/context'

import { COMPLETE_DOCUSIGN_EDIT_URL } from './icf-document/complete-docusign-edit/complete-docusign-edit'
import {
  IcfDocumentSignerRole,
  IcfDocumentCheckRole,
  icfDocumentSignerRoles,
} from './icf-document/entity'
import { useIcfDocumentHospital } from './use-icf-document-hospital'

const roleQueryParamValue: Record<
  IcfDocumentSignerRole | IcfDocumentCheckRole,
  string
> = {
  [icfDocumentSignerRoles.Dr]: 'dr',
  [icfDocumentSignerRoles.CRC]: 'crc',
  [icfDocumentSignerRoles.Patient]: 'patient',
  [icfDocumentSignerRoles.Representative]: 'representative',
}

export const useDocuSignPreview = () => {
  const { selectedTrial } = useSelectedTrial()
  const { uid: trialUid } = selectedTrial
  const { selectedTrialHospitalUid } = useIcfDocumentHospital()
  const redirect = useCallback(
    ({
      dsTemplateId,
      role,
    }: {
      dsTemplateId: string
      role: IcfDocumentSignerRole | IcfDocumentCheckRole
    }) => {
      const url = `${SERVER_URL}/trials/${trialUid}/trial_hospitals/${selectedTrialHospitalUid}/docusign_templates/${dsTemplateId}/preview/${roleQueryParamValue[role]}?return_url=${COMPLETE_DOCUSIGN_EDIT_URL}`
      window.open(url, '_blank', 'noreferrer')
    },
    [trialUid, selectedTrialHospitalUid],
  )
  return { redirect }
}
